import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

type RouteSavedPopupProps = {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
};

export default function RouteSavedPopup({
  isOpen,
  onClose,
  message = "This route is now saved to your account! Head over to your routes page to see all your saved routes.",
}: RouteSavedPopupProps) {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate("/routes");
  };

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="usage-limit-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="usage-limit-dialog-title">Route Saved</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button style={{borderColor:'black', color:'black'}} variant="outlined" onClick={onClose}>
          Close
        </Button>
        <Button style={{backgroundColor:'black'}} variant="contained" color="primary" onClick={handleUpgrade}>
          View My Routes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
